import { computed } from 'vue'

/**
 * Composable para formatear montos de dinero
 */
export function useFormatoMoneda() {
  /**
   * Formatea un número como moneda
   */
  const formatearMoneda = (monto, moneda = 'MXN') => {
    if (monto === null || monto === undefined) return '$0.00'

    const opciones = {
      MXN: { symbol: '$', locale: 'es-MX' },
      USD: { symbol: '$', locale: 'en-US' },
      EUR: { symbol: '€', locale: 'es-ES' }
    }

    const config = opciones[moneda] || opciones.MXN

    return new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency: moneda,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(monto)
  }

  /**
   * Formatea un número sin símbolo de moneda
   */
  const formatearNumero = (numero, decimales = 2) => {
    if (numero === null || numero === undefined) return '0.00'

    return new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales
    }).format(numero)
  }

  /**
   * Obtiene la clase de color según si el monto es positivo o negativo
   */
  const obtenerClaseColor = (monto) => {
    if (monto > 0) return 'text-green-600 dark:text-green-400'
    if (monto < 0) return 'text-red-600 dark:text-red-400'
    return 'text-gray-600 dark:text-gray-400'
  }

  /**
   * Parsea una cadena de moneda a número
   */
  const parsearMoneda = (cadena) => {
    if (typeof cadena === 'number') return cadena
    if (!cadena) return 0

    const numero = cadena.toString().replace(/[^0-9.-]/g, '')
    return parseFloat(numero) || 0
  }

  return {
    formatearMoneda,
    formatearNumero,
    obtenerClaseColor,
    parsearMoneda
  }
}

export default useFormatoMoneda
